import {
  BOX_PAGE_ADVISER_DETAIL,
  BOX_PAGE_AUTH,
  BOX_PAGE_FEED,
  BOX_PAGE_PROFILE_EDIT,
  BOX_PAGE_QUESTIONS,
  BOX_PAGE_QUESTION_ADD,
  BOX_PAGE_QUESTION_ANSWER,
  BOX_PAGE_QUESTION_DETAIL,
  BOX_PATH_ADVISERS_ME_EDIT,
  BOX_PATH_FEED,
  BOX_PATH_QUESTIONS_ADD,
  BOX_PATH_TOP_ADVISERS,
  BOX_PATH_TOP_QUESTIONS,
} from '../../../core/entities/box/constants';

type CreateBoxPathArgs = {
  page: string;
  questionId?: number;
  adviserName?: string;
  focusAnswerId?: number;
};

export const createBoxPath = ({
  page,
  questionId,
  adviserName,
  focusAnswerId,
}: CreateBoxPathArgs) => {
  switch (page) {
    case BOX_PAGE_FEED: {
      return BOX_PATH_FEED;
    }

    case BOX_PAGE_QUESTIONS: {
      return BOX_PATH_TOP_QUESTIONS;
    }

    case BOX_PAGE_QUESTION_ADD: {
      return adviserName
        ? `${BOX_PAGE_QUESTION_ADD}?adviserName=${adviserName}`
        : BOX_PATH_QUESTIONS_ADD;
    }

    case BOX_PAGE_QUESTION_DETAIL: {
      // MEMO: 干渉しないために{}で囲む
      let path = `${BOX_PATH_TOP_QUESTIONS}/${Number(questionId)}`;
      if (focusAnswerId) {
        path = `${path}?focusAnswer=${focusAnswerId}`;
      }

      return path;
    }

    case BOX_PAGE_QUESTION_ANSWER: {
      return `${BOX_PATH_TOP_QUESTIONS}/${Number(questionId)}/answer`;
    }

    case BOX_PAGE_ADVISER_DETAIL: {
      return `${BOX_PATH_TOP_ADVISERS}/${String(adviserName)}`;
    }

    case BOX_PAGE_PROFILE_EDIT: {
      return BOX_PATH_ADVISERS_ME_EDIT;
    }

    case BOX_PAGE_AUTH: {
      return BOX_PAGE_AUTH;
    }

    default: {
      return '/';
    }
  }
};
